import React from "react"
import { ScreenMessage } from "./ScreenMessage.compound"

export function EmptyTableMessage(props) {
  const {
    classNameContainer = "",
    className = "",
    title = "No se encontró información",
    message = "Intenta aplicar otros filtros",
  } = props

  return (
    <div className={`empty-message-center mx-auto ${classNameContainer}`}>
      <ScreenMessage
        className={`mx-auto ${className}`}
        title={title}
        message={message}
      />
    </div>
  )
}
